import React from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import styles from './FilterTabs.module.scss';

const FilterTabs = ({ activeTab, setActiveTab, inactiveTabState, setInactiveTabState }) => {
    return (
        <>
            <Nav className={styles.filterTabs}>
                <NavItem className={styles.navItem}>
                    <NavLink
                        className={`${styles.navLink} ${activeTab === 'all' ? styles.activeTab : ''}`}
                        onClick={() => setActiveTab('all')}
                    >
                        All
                    </NavLink>
                </NavItem>
                <NavItem className={styles.navItem}>
                    <NavLink
                        className={`${styles.navLink} ${activeTab === 'active' ? styles.activeTab : ''}`}
                        onClick={() => setActiveTab('active')}
                    >
                        Active
                    </NavLink>
                </NavItem>
                <NavItem className={styles.navItem}>
                    <NavLink
                        className={`${styles.navLink} ${activeTab === 'underApproval' ? styles.activeTab : ''}`}
                        onClick={() => setActiveTab('underApproval')}
                    >
                        Under Approval
                    </NavLink>
                </NavItem>
                <NavItem className={styles.navItem}>
                    <NavLink
                        className={`${styles.navLink} ${activeTab === 'inactive' ? styles.activeTab : ''}`}
                        onClick={() => setActiveTab('inactive')}
                    >
                        Inactive
                    </NavLink>
                </NavItem>
            </Nav>

            {activeTab === 'inactive' && (
                <Nav className={styles.filterTabs}>
                    <NavItem className={styles.navItem}>
                        <NavLink
                            className={`${styles.navLink} ${inactiveTabState === 'outOfStock' ? styles.activeTab : ''}`}
                            onClick={() => setInactiveTabState('outOfStock')}
                        >
                            Out of stock
                        </NavLink>
                    </NavItem>
                    <NavItem className={styles.navItem}>
                        <NavLink
                            className={`${styles.navLink} ${inactiveTabState === 'restricted' ? styles.activeTab : ''}`}
                            onClick={() => setInactiveTabState('restricted')}
                        >
                            Restricted
                        </NavLink>
                    </NavItem>
                    <NavItem className={styles.navItem}>
                        <NavLink
                            className={`${styles.navLink} ${inactiveTabState === 'deleted' ? styles.activeTab : ''}`}
                            onClick={() => setInactiveTabState('deleted')}
                        >
                            Deleted
                        </NavLink>
                    </NavItem>
                </Nav>
            )}
        </>
    );
};

export default FilterTabs;
